import { z } from "zod";
/** The subset a grant row may carry (read/write/admin, spec § Grants). */
export const grantLevelSchema = z.enum(["read", "write", "admin"]);
/** Create a catalog entry (owner-only, ticket 05). */
export const catalogCreateSchema = z.object({
    name: z.string().trim().min(1, "name is required").max(120),
    roots: z.array(z.string().uuid("root must be a UUID")).optional(),
    isDefault: z.boolean().optional(),
});
/**
 * Patch a catalog entry's name / default flag / roots (owner-only). At least
 * one field must be present; roots always replaces the entry's roots.
 */
export const catalogPatchSchema = z
    .object({
    name: z.string().trim().min(1, "name is required").max(120).optional(),
    isDefault: z.boolean().optional(),
    roots: z.array(z.string().uuid("root must be a UUID")).optional(),
})
    .refine((v) => v.name !== undefined || v.isDefault !== undefined || v.roots !== undefined, { message: "at least one of name, isDefault, roots is required" });
/** Set a grantee's level on a catalog entry AC (owner-only). */
export const aclSetSchema = z.object({
    level: grantLevelSchema,
});
/**
 * Reassign a container as a root of a catalog entry
 * (PUT /api/catalogs/:id/roots/:containerId, catalog-root assignment). A
 * same-home reassignment follows the move endpoint's write+write split; when
 * the destination entry lives in another home it is an ownership transfer and
 * requires both the container `version` and `confirmTransfer`, exactly like the
 * move flow (container-catalog-transfer 08).
 */
export const catalogRootAssignSchema = z.object({
    version: z.number().int().nonnegative().optional(),
    confirmTransfer: z.boolean().optional(),
});
/**
 * Grantee-side catalog ACL (catalog-entry-sharing): `users.json` stores, per
 * user, a map of catalog entry id → level. Keys are server-assigned UUIDs.
 */
export const catalogSharesSchema = z.record(z.string().uuid("shares key must be a catalog entry UUID"), grantLevelSchema);
//# sourceMappingURL=catalog.js.map